import React, { useRef } from "react";
import { useInView } from "framer-motion";

// css
import "./di-styles.css";

// charts
// import ConnectedChart from "./charts/ConnectedDevicesChart";
// import GlobalDataChart from "./charts/GlobalDataChart";
// import InfrastructureExpansionChart from "./charts/InfrastructureExpansionChart";

import ConnectedDevicesChartRe from "./charts/ConnectedDevicesChartRe";
import GlobalDataChartRe from "./charts/GlobalDataChartRe";
import InfrastructureExpansionChartRe from "./charts/InfrastructureExpansionChartRe";

const CurrentMarket = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  return (
    <section id="current-market" className="current-market-section" ref={ref}>
      <div className="main-padding">
        <div>
          <div className="current-market-inner">
            <h1 className="sub-header t-center">
              Current State of the Digital Infrastructure Market
            </h1>
            <div
              className="current-market-inner-grid"
              style={{
                // transform: isInView ? "none" : "translateX(-200px)",
                opacity: isInView ? 1 : 0,
                transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
              }}
            >
              <div className="current-market-grid-item">
                <h3 className="fw-5 t-center">
                  An onslaught of "smart" devices require connectivity
                </h3>
                {isInView ? ( // Use isInView for each div if you want the animation to occur in view. Otherwise it gets rendered beforehand and doesn't animate
                  <div style={{ position: "relative", width: "100%" }}>
                    {/* <ConnectedChart /> */}
                    <ConnectedDevicesChartRe />
                  </div>
                ) : null}
              </div>
              <div className="current-market-grid-item">
                <h3 className="fw-5 t-center">
                  We're creating colossal amounts of data that require storage,
                  processing and delivery
                </h3>
                {isInView ? (
                  <div style={{ position: "relative", width: "100%" }}>
                    {/* <GlobalDataChart /> */}
                    <GlobalDataChartRe />
                  </div>
                ) : null}
              </div>
              <div className="current-market-grid-item">
                <h3 className="fw-5 t-center">
                  Significant infrastructure expansion is needed to meet demand
                </h3>
                {isInView ? (
                  <div style={{ width: "100%" }}>
                    {/* <InfrastructureExpansionChart /> */}
                    <InfrastructureExpansionChartRe />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CurrentMarket;
